import { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import store from 'store2'
import moment from 'moment'
import setQuery from 'set-query-string'
import find from 'lodash/find'
import filter from 'lodash/filter'
import each from 'lodash/each'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import map from 'lodash/map'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { StickyHeader, FiltersLa, TripsComponent, BoatComponent } from '../components'
import { parseQuery, generateMonthPicker } from '../utils'
import Loader from '../components/helpers/Loader'
import ItineraryPopup from '../components/popups/ItineraryPopup'
import MobileFilterToggle from '../components/search/MobileFilterToggle'
import { guestPickerKeys } from './SearchPageDr'
import { prepareGuestSplitting } from '../components/resort/ResortPricing'
import API from '../api'

const SORT_BY = [
  {
    title: <FormattedMessage id='feature' defaultMessage='Featured' />,
    value: '-shop_rating',
  }, {
    title: <FormattedMessage id='cheapest' defaultMessage='Cheapest' />,
    value: 'minimum_price',
  }, {
    title: <FormattedMessage id='guest_rating' defaultMessage='Guest ratings' />,
    value: '-rating',
  }]
const monthes = generateMonthPicker()

const filtersKeys = [
  'departure_date',
  'departure_date_custom',
  'routes',
  'marine_life_critters',
  'marine_life_group_critters',
  'experience',
  'diving_intensity',
  'rating',
  'parameters',
  'themes',
  'harbours',
  'duration',
  'price',
  'is_promotion',
  'sponsors',
  'view',
  'ordering',
  'shop',
  'tag',
]

const filtersToClean = [
  'routes',
  'marine_life_critters',
  'marine_life_group_critters',
  'experience',
  'diving_intensity',
  'rating',
  'parameters',
  'themes',
  'harbours',
  'duration',
  'price',
  'is_promotion',
  'sponsors',
  'tag',
]
class SearchPageComponent extends Component {
  constructor(props) {
    super(props)

    let departureDate = store('departure_date')
    let roomParams = store.get('roomParams') || {}
    let selectedParams = parseQuery()
    let filtersCount = 0
    let filterObject = {}

    if(!selectedParams.departure_date) {
      if(departureDate && departureDate.id !== 'available' && departureDate.id !== 'all') {
        setQuery({ departure_date: store('departure_date').id })
      } else if(store('date') || store('departure_date_custom')) {
        let dateObj = store('departure_date_custom') || store('date')[0]
        let date = moment(dateObj).startOf('month').format('YYYY-MM-DD')
        let month = filter(monthes, { from: date })

        if(month.length) {
          setQuery({ 'departure_date': month[0].id })
        }
        if(store('departure_date_custom')) {
          setQuery({ departure_date_custom: store('departure_date_custom') })
        }
      }
      selectedParams = parseQuery()
    }

    if(selectedParams) {
      each(selectedParams, function(val, key) {
        if(filtersKeys.indexOf(key) >= 0) {
          if(key === 'departure_date') {
            let departure = find(monthes, {
              id: val,
            })
            // For monthpicker
            filterObject['departure_date_month'] = departure
            if(departure) {
              filterObject[key] = departure.from
              selectedParams[key] = departure.from
            }
          } else if(key === 'is_promotion') {
            filterObject[key] = val
            filtersCount++
          } else if(key === 'view' || key === 'departure_date_custom' || key === 'ordering') {
            filterObject[key] = val
          } else if(isArray(val)) {
            filterObject[key] = {}
            filtersCount++
            each(val, function(v) {
              filterObject[key][v] = true
            })
          } else {
            filterObject[key] = {}
            filterObject[key][val] = true
            filtersCount++
          }
        }
      })
    }

    this.state = {
      selectedParams: {
        ordering: SORT_BY[0].value,
        view: 'boats',
        ...selectedParams,
        divers: roomParams.divers,
        students: roomParams.students,
        nonDivers: roomParams.nonDivers,
        rooms: roomParams.rooms,
        totalGuests: roomParams.totalGuests,
        guests_split: roomParams.totalGuests ? prepareGuestSplitting(get(roomParams, 'guest_split', get(roomParams, 'details', [roomParams]))) : undefined,
      },
      getNewData: false,
      selectedFilters: filterObject,
      numberOfBoats: this.props.totalCount || 0,
      numberOfTrips: 0,
      numberOfBoatsParent: 0,
      filtersCount,
    }
  }

  updateParams = (params, clearPage) => {
    const { selectedParams } = this.state
    const firstSeen = false
    let filtersCount = 0

    if(clearPage) {
      this.setState({
        page: 1,
      })
      setQuery({ page: 1 })
    }

    this.setState({
      selectedFilters: {
        ordering: SORT_BY[0].value,
        view: 'boats',
        ...this.state.selectedFilters,
        ...params,
      },
    }, () => {
      let obj = {}
      let guests = {
        totalGuests: selectedParams.totalGuests,
        divers: selectedParams.divers,
        students: selectedParams.students,
        nonDivers: selectedParams.nonDivers,
        rooms: selectedParams.rooms,
        guests_split: selectedParams.guests_split,
      }
      each(this.state.selectedFilters, function(val, key) {
        if(filtersKeys.indexOf(key) >= 0) {
          if(key === 'view' || key === 'departure_date_custom' || key === 'ordering') {
            if(key === 'view' && firstSeen) {
              return true
            }

            obj[key] = val
          } else if(key === 'departure_date') {
            let departure = find(monthes, {
              from: val,
            })

            obj[key] = departure.id
          } else if(key === 'is_promotion') {
            obj[key] = val.promotion
          } else {
            obj[key] = filter(map(val, function(v, k) {
              if(v) {
                return +k
              }

              return null
            }), function(v) {
              return v || typeof v === 'number'
            })
          }

          if((isArray(obj[key]) && obj[key].length) || (key === 'is_promotion' && obj[key])) {
            filtersCount++
          }
        } else if(guestPickerKeys.indexOf(key) >= 0) {
          guests[key] = key === 'guests_split' && val ? prepareGuestSplitting(val) : val
        }
      })

      setQuery(obj)

      if(obj.departure_date) {
        let departure = find(monthes, {
          id: obj.departure_date,
        })

        obj.departure_date = departure.from
        obj.selected_month = departure.id !== '30-days'

        store('departure_date', departure)
        store('date', [departure.from, departure.to])
      } else if(obj.departure_date_custom) {
        store('departure_date_custom', obj.departure_date_custom)
        store('date', [obj.departure_date_custom, moment(obj.departure_date_custom).add(30, 'd').format('YYYY-MM-DD')])
        store.remove('departure_date')
      } else {
        store.remove('departure_date')
        store.remove('departure_date_custom')
        store.remove('date')
      }

      this.setState({
        selectedParams: {
          ...obj,
          ...guests,
        },
        filtersCount,
      })
    })
  }

  clearSelectedFilters = () => {
    let cleanObj = {}
    each(filtersToClean, function(filter) {
      cleanObj[filter] = undefined
    })

    setQuery(cleanObj)

    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        ...cleanObj,
      },
      selectedParams: {
        ...this.state.selectedFilters,
        ...cleanObj,
      },
      filtersCount: 0,
    })
  }

  clearDates = () => {
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        departure_date_month: null,
      },
      selectedParams: {
        ...this.state.selectedParams,
        ...this.state.selectedFilters,
        departure_date: undefined,
        departure_date_month: undefined,
      },
    })

    setQuery({ departure_date: null })
    store.remove('departure_date')
    store.remove('departure_date_custom')
    store.remove('date')
  }

  updateOrdering = (item) => {
    if(this.state.selectedParams.ordering === item.value) {
      if(item.value[0] === '-') {
        item.value = item.value.substr(1)
      } else {
        item.value = '-' + item.value
      }
    }

    this.updateParams({
      ordering: item.value,
    })
  }

  isActiveFilter(item) {
    let className = 'option '
    let selectedOption = this.state.selectedParams.ordering
    let indexOf = item.value.indexOf(selectedOption && selectedOption[0] === '-' ? selectedOption.substring(1) : selectedOption)

    if(indexOf !== -1 && indexOf <= 1) {
      className += 'active '
    }
    if(item.value.indexOf('-') === 0) {
      className += 'desc'
    }

    return className
  }

  triggerApi = () => {
    this.setState({
      getNewData: !this.state.getNewData,
    })
  }

  setNumberOfItems = (number, type) => {
    let obj = { [type]: number }

    this.setState(obj)
  }

  setNumberOfBoatsParent = (number) => {
    this.setState({
      numberOfBoatsParent: number,
    })
  }

  openModal() {
    this.setState({ modalIsOpen: true })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = '#f00'
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  componentDidMount() {
    API('booking/insurances/').get().then((insurance) => {
      this.setState({
        insurance,
      })
    })
  }

  render() {
    return (
      <div className='search-page-la'>
        <StickyHeader locationTitle={this.props.title} />
        <ReactTooltip type='solid' id='global' />
        <ItineraryPopup />
        <div className='search-wrapper'>
          <div className='main-content'>
            <FiltersLa
              triggerApi={this.triggerApi}
              resortDetails={this.props.resortDetails}
              monthes={monthes}
              isWidget={this.props.isWidget}
              selectedFilters={this.state.selectedFilters}
              items={this.props.filters}
              title={this.props.title}
              updateParams={this.updateParams}
              clearDates={this.clearDates}
              clearSelectedFilters={this.clearSelectedFilters}
              trustpilotLocale={this.props.trustpilotLocale}
              filtersCount={this.state.filtersCount}
            />
            <div className={`result-list ${this.props.pageLoader ? 'loading' : ''}`}>
              <Loader />
              <div className='results-head'>
                <h1>
                  {
                    this.state.selectedParams.view === 'boats'
                      ? (<FormattedMessage
                        id='search.title.boats'
                        values={{
                          qty: this.state.numberOfBoats,
                          location: this.props.inTitle,
                        }}
                        defaultMessage='{ qty, plural, one {# liveaboard} other {# liveaboards } } { location }' />)
                      : (
                        <FormattedMessage
                          id='search.title.trips'
                          values={{
                            qty: this.state.numberOfTrips,
                            location: this.props.inTitle,
                          }}
                          defaultMessage='{ qty, plural, one {# trip} other {# trips } } { location }' />
                      )
                  }
                </h1>
                <div className='results-actions'>
                  <div className='search-ordering'>
                    <label className='bold'>
                      <FormattedMessage id='sort_by' defaultMessage='Sort by' />:
                    </label>
                    <ul className='pt-selector' >
                      {
                        SORT_BY.map((sort, index) => {
                          return (<li key={index} onClick={() => this.updateOrdering(sort)} className={this.isActiveFilter(sort)}>
                            { sort.title }
                            <span className='arrow'>↓</span>
                          </li>)
                        })
                      }
                    </ul>
                  </div>
                  <div className='results-group-by' ng-style="search.topLevelPage > 1 &amp;&amp; { 'visibility':'hidden' }">
                    <label className='bold'>
                      <FormattedMessage id='group_by' defaultMessage='Group by' />:
                    </label>
                    <div className='pt-selector'>
                      <span className={`option ${this.state.selectedParams.view === 'boats' ? 'active' : ''}`} onClick={() => { this.updateParams({ view: 'boats' }, this.state.selectedParams.view !== 'boats') }}>
                        <FormattedMessage id='boats' defaultMessage='Boats' />
                      </span>
                      <span className={`option ${this.state.selectedParams.view !== 'boats' ? 'active' : ''}`} onClick={() => { this.updateParams({ view: 'dates' }, this.state.selectedParams.view === 'boats') }}>
                        <FormattedMessage id='departure_dates' defaultMessage='Departure dates' />
                      </span>
                    </div>
                  </div>
                  <MobileFilterToggle filtersCount={this.state.filtersCount} />
                </div>
              </div>
              {
                this.state.selectedParams.view === 'boats' ? (
                  <Fragment>
                    <BoatComponent
                      setNumberOfItems={this.setNumberOfItems}
                      selectedParams={this.state.selectedParams}
                      getNewData={this.state.getNewData}
                      insurance={this.state.insurance && this.state.insurance[0]}
                      {...this.props} />

                    { this.props.totalCount < 10 ? (
                      <div className='top-level-items'>
                        <h2><FormattedMessage id='search.other_la' defaultMessage='{qty} other {qty, plural, one {liveaboard} other {liveaboards}} {location}' values={{ qty: this.state.numberOfBoatsParent, location: this.props.parentTitle }} /></h2>
                        <div className='update-search-wrapper'>
                          <a href={this.props.parentUrl} className='btn-red'>
                            <i className='font-icons find-icon' />
                            <FormattedMessage id='update_search' defaultMessage='Update search' />
                          </a>
                          <FormattedMessage id='search.liveaboards_in' defaultMessage='Liveaboards {location}' values={{ location: this.props.parentTitle }} />
                        </div>
                        <BoatComponent
                          getNewData={this.state.getNewData}
                          parentElement
                          setNumberOfItems={this.setNumberOfBoatsParent}
                          selectedParams={this.state.selectedParams}
                          slug={this.props.parentSlug}
                          model={this.props.parentModel}
                          pk={this.props.parentPk}
                          resortDetails={this.props.parentResortDetails}
                          insurance={this.state.insurance && this.state.insurance[0]} />
                      </div>) : '' }
                  </Fragment>
                ) : (<TripsComponent
                  getNewData={this.state.getNewData}
                  setNumberOfItems={this.setNumberOfItems}
                  selectedParams={this.state.selectedParams}
                  insurance={this.state.insurance && this.state.insurance[0]}
                  {...this.props} />)
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    numberOfTrips: state.numberOfTrips,
    pageLoader: state.pageLoader,
  })
)(SearchPageComponent)
